import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './inputFormattedEmail.css';
import useTranslator from '../../../translation/hooks/useTranslator';
import { validateEmail } from '../../../utils/validateEmail';

const DEFAULT_EMAIL_VALUE = { email: '', isMain: false, invalid: false };

// Garante que o primeiro e-mail seja sempre o principal e os demais não.
const normalizeMain = (emails) => emails.map((emailItem, rowIndex) => ({ ...emailItem, isMain: rowIndex === 0 }));

export const InputFormattedEmail = props => {
  const { setValue, field, index } = props;
  const { Translation } = useTranslator();

  const [valueArray, setValueArray] = useState([{ ...DEFAULT_EMAIL_VALUE, isMain: true }]);

  useEffect(() => {
    const isValid = !valueArray.some(emailItem => emailItem.invalid);
    const payload = valueArray.map(({ email, isMain }) => ({ email, isMain }));
    setValue(isValid ? payload : null, index, field.ObjectKey, field.Required, isValid, Translation('FIELDS.INVALID_INPUT'));
  }, [valueArray]);

  const handleInputChange = useCallback(rowIndex => (email) => {
    const tempValueArray = [...valueArray];

    tempValueArray[rowIndex] = {
      ...tempValueArray[rowIndex],
      email: email.trim(),
      invalid: email ? !validateEmail(email) : false,
    };

    setValueArray([...tempValueArray]);
  }, [valueArray])

  const addRow = useCallback(() => {
    setValueArray(normalizeMain([...valueArray, { ...DEFAULT_EMAIL_VALUE }]));
  }, [valueArray])

  const removeRow = useCallback(rowIndex => () => {
    setValueArray(normalizeMain(valueArray.filter((emailItem, itemIndex) => itemIndex !== rowIndex)));
  }, [valueArray])

  return (
    <div className='form-content__email-wrapper'>
      {valueArray.map((emailItem, rowIndex) => (
        <div className='form-content__email-entry' key={rowIndex}>
          <div className='form-content__email-row'>
            <div className='form-content__email-field'>
              <input
                className={`form-content__input ${emailItem.invalid ? '--invalid' : ''}`}
                onChange={(event) => handleInputChange(rowIndex)(event.target.value)}
                value={emailItem.email}
                name={field.FieldKey}
                type='email'
              />
              {emailItem.isMain && <span className='form-content__email-badge'>{Translation('FIELDS.EMAIL_MAIN')}</span>}
            </div>
            {valueArray.length === 1
              ? (
                <button type='button' className='form-content__email-btn' onClick={addRow}>
                  <img src='/assets/plus.svg' alt='' />
                </button>
              )
              : (
                <button type='button' className='form-content__email-btn' onClick={removeRow(rowIndex)}>
                  <img src='/assets/trash.svg' alt='' />
                </button>
              )}
          </div>
          {emailItem.invalid && <div className='form-content__validation'>{Translation('FIELDS.INVALID_INPUT')}</div>}
        </div>
      ))}

      {valueArray.length > 1 && (
        <button type='button' className='form-content__email-add-more' onClick={addRow}>
          <img src='/assets/plus.svg' alt='' />
          {Translation('FIELDS.ADD_EMAIL')}
        </button>
      )}
    </div>
  );
}

InputFormattedEmail.propTypes = {
  value: PropTypes.array,
  setValue: PropTypes.func.isRequired,
  field: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
}
